"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationSiteRelationshipType = exports.OrganizationLiveStats = exports.OrganizationFeatures = void 0;
const swagger_proxy_1 = require("./swagger-proxy");
const class_validator_proxy_1 = require("./class-validator-proxy");
/**
 * Features that are enabled for an organization.
 */
class OrganizationFeatures {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether theme customization is enabled for this organization",
        example: true,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], OrganizationFeatures.prototype, "themeCustomizationEnabled", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether compliance reporting is enabled for this organization",
        example: false,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], OrganizationFeatures.prototype, "complianceReportingEnabled", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether tiered pricing is enabled for this organization",
        example: false,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], OrganizationFeatures.prototype, "tieredPricingEnabled", void 0);
exports.OrganizationFeatures = OrganizationFeatures;
/**
 * Live stats for a given organization.
 */
class OrganizationLiveStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total power consumption across all chargers in the organization (kW)",
        example: 450.5,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], OrganizationLiveStats.prototype, "totalChargerPowerKw", void 0);
exports.OrganizationLiveStats = OrganizationLiveStats;
var OrganizationSiteRelationshipType;
(function (OrganizationSiteRelationshipType) {
    OrganizationSiteRelationshipType["OWNER"] = "owner";
    OrganizationSiteRelationshipType["STAKEHOLDER"] = "stakeholder";
})(OrganizationSiteRelationshipType = exports.OrganizationSiteRelationshipType || (exports.OrganizationSiteRelationshipType = {}));
